import { createAction } from "@reduxjs/toolkit";

import type { ContentLanguage, ContentLanguageUpdate } from "../../../schemas/index.ts";
import { withPayloadType } from "../actionHelpers.ts";

export const addContentLanguageAction = createAction(
  "ADD_CONTENT_LANGUAGE",
  withPayloadType<Omit<ContentLanguage, "isPrimary">>(),
);

export const updateContentLanguageAction = createAction(
  "UPDATE_CONTENT_LANGUAGE",
  withPayloadType<ContentLanguageUpdate & { code: string }>(),
);
